type PriceTabItem = { id: string; en: string; jp: string };

type PriceTabsProps = {
  tabs: PriceTabItem[];
  activeId: string;
  onChange: (id: string) => void;
};

export default function PriceTabs({ tabs, activeId, onChange }: PriceTabsProps) {
  return (
    <div className="border-b border-background-300/80">
      {/* PC: 横並びタブ */}
      <div role="tablist" aria-label="料金カテゴリ" className="hidden lg:flex lg:flex-wrap lg:gap-x-1">
        {tabs.map((tab) => {
          const isActive = tab.id === activeId;
          return (
            <button
              key={tab.id}
              type="button"
              role="tab"
              aria-selected={isActive}
              onClick={() => onChange(tab.id)}
              className={`relative px-5 pb-5 pt-6 text-left transition-colors ${
                isActive ? "text-foreground-950" : "text-foreground-500 hover:text-foreground-800"
              }`}
            >
              <span
                className={`en-eyebrow block text-[9px] transition-colors ${
                  isActive ? "text-secondary-700" : "text-foreground-400"
                }`}
              >
                {tab.en}
              </span>
              <span className="mt-2 block whitespace-nowrap font-heading text-[15px]">{tab.jp}</span>
              <span
                aria-hidden
                className={`absolute inset-x-3 bottom-0 h-px transition-colors ${
                  isActive ? "bg-accent-500" : "bg-transparent"
                }`}
              />
            </button>
          );
        })}
      </div>

      {/* スマホ・タブレット: 横スクロールタブ */}
      <div className="no-scrollbar -mx-6 flex gap-2 overflow-x-auto px-6 py-4 md:-mx-10 md:px-10 lg:hidden">
        {tabs.map((tab) => {
          const isActive = tab.id === activeId;
          return (
            <button
              key={tab.id}
              type="button"
              role="tab"
              aria-selected={isActive}
              onClick={() => onChange(tab.id)}
              className={`flex shrink-0 flex-col items-start rounded-full border px-4 py-2.5 transition-colors ${
                isActive
                  ? "border-primary-600 bg-primary-600 text-background-50"
                  : "border-background-300 bg-background-50 text-foreground-700"
              }`}
            >
              <span
                className={`en-eyebrow block text-[8px] ${isActive ? "text-background-200" : "text-foreground-400"}`}
              >
                {tab.en}
              </span>
              <span className="mt-1 whitespace-nowrap font-heading text-[13px]">{tab.jp}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}